import React from "react";
import Quotes from "../Apm/Quote/Quotes";

const MyQuotes = () => {
  return (
    <React.Fragment>
      <Quotes />
    </React.Fragment>
  );
};

export default MyQuotes;
